import { useEffect, useRef, useState } from "react";
import Text from "../../Components/Text/Text";
import Button from "../../Components/Button/Button";
import { useWindowScroll } from "../../hooks/useWindowScroll";
import { useNavigate } from "react-router-dom";
import PBImage from "../../assets/images/case-studies/thumb/PB.png";
import EYSImage from "../../assets/images/case-studies/thumb/EYS.png";
import NTUCImage from "../../assets/images/case-studies/thumb/NTUC.png";

const DEFAULT_CASE_STUDIES = [
  {
    title: "Popular Bookstore",
    description:
      "The aim of this mobile application is to provide a platform to build better relationships with consumers. The aim of this mobile application is to provide a platform to build better relationships with consumers.",
    hint: "E-commerce, Android, iOS Mobile App",
    path: "/case-studies/popular-bookstores",
    image: PBImage,
  },
  {
    title: "Eu Yan Sang",
    description:
      "Turning The Digitalisation Of A 140 Year Old Business Into An Opportunity For Innovation.",
    hint: "E-commerce, Android, iOS Mobile App",
    path: "/case-studies/eu-yan-sang",
    image: EYSImage,
  },
  {
    title: "NTUC Income",
    description:
      "Accelerating Adoption Of Electric Vehicles For A Cleaner, Greener Singapore.",
    hint: "E-commerce, Android, iOS Mobile App",
    path: "/case-studies/ntuc-income",
    image: NTUCImage,
  },
];

export default function CaseStudiesPreview({ caseStudies }) {
  const ref = useRef();
  const { y, height } = useWindowScroll();

  const { offsetTop: elOffsetTop } = ref?.current || {};
  const boundary = elOffsetTop - height / 1.5;
  const show = y > boundary;

  return (
    <section ref={ref}>
      <div className="py-12 px-4 mx-auto container">
        <Text
          type="h2"
          size="lg"
          className={`font-semibold transition-all duration-700 ${
            show ? "" : "opacity-0 translate-x-96"
          }`}
        >
          Find out how we help you achieve success
        </Text>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 place-items-center my-12">
          {(caseStudies || DEFAULT_CASE_STUDIES).map((item, index) => (
            <Item key={item.title} index={index} show={show} {...item} />
          ))}
        </div>
      </div>
    </section>
  );
}

function Item({ title, image, description, path, index, show }) {
  const [active, setActive] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const time = show ? index * 200 : 0;
    const timeId = setTimeout(() => setActive(show), time);
    return () => clearTimeout(timeId);
  }, [show, index]);

  return (
    <div
      role="button"
      className={`group transition-all duration-500 h-full ${
        active ? "opacity-90" : "opacity-0 translate-y-96"
      } rounded-lg shadow-lg overflow-hidden border border-gray-200 filter grayscale hover:grayscale-0 hover:opacity-100 flex flex-col`}
      onClick={() => navigate(path)}
    >
      <img src={image} alt={title} className="h-[500px] object-cover" />
      <div className="p-4 flex-1">
        <Text type="p" size="md">
          {title}
        </Text>
        <Text type="p" className="my-4">
          {description}
        </Text>
      </div>
      <Button variant="outline">LEARN MORE</Button>
    </div>
  );
}
